import environment from 'constants/environment';

import { setAuthToken } from './requestConfig';

export const ensureAdminAuth = async (): Promise<void> => {
  if (environment.adminToken) {
    setAuthToken(environment.adminToken);
  }
};
